var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7673 17.7668C17.1727 18.3583 16.8371 19.1615 16.834 20.0002C16.834 20.84 17.1676 21.6455 17.7615 22.2394C18.3553 22.8332 19.1608 23.1668 20.0007 23.1668C20.8393 23.1638 21.6425 22.8281 22.234 22.2335",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C18.1211 10.5 16.2844 11.0572 14.7221 12.101C13.1598 13.1449 11.9422 14.6286 11.2231 16.3645C10.5041 18.1004 10.316 20.0105 10.6825 21.8534C11.0491 23.6962 11.9539 25.3889 13.2825 26.7175C14.6111 28.0461 16.3038 28.9509 18.1466 29.3175C19.9895 29.684 21.8996 29.4959 23.6355 28.7769C25.3714 28.0578 26.8551 26.8402 27.899 25.2779C28.9428 23.7156 29.5 21.8789 29.5 20",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 4.16675C16.8688 4.16675 13.8076 5.09536 11.2038 6.83515C8.60003 8.57493 6.57063 11.0478 5.37224 13.9409C4.17385 16.8341 3.8603 20.0176 4.47123 23.089C5.08217 26.1604 6.59014 28.9816 8.80448 31.1959C11.0188 33.4103 13.84 34.9182 16.9114 35.5292C19.9828 36.1401 23.1663 35.8266 26.0595 34.6282C28.9526 33.4298 31.4255 31.4004 33.1653 28.7966C34.9051 26.1928 35.8337 23.1316 35.8337 20.0001M25.8753 14.1267L21.5837 18.4167",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 9.74008L29.5004 10.5001L30.2604 5.10008C30.2659 5.03735 30.2527 4.97439 30.2223 4.91924C30.1919 4.86409 30.1458 4.81924 30.0898 4.79044C30.0338 4.76164 29.9705 4.75018 29.9079 4.75754C29.8454 4.7649 29.7865 4.79073 29.7387 4.83174L26.1587 8.39341C25.791 8.76378 25.5205 9.21929 25.3714 9.71942C25.2222 10.2195 25.1989 10.7488 25.3037 11.2601L25.8737 14.1267L28.7404 14.6951C29.2516 14.7998 29.7809 14.7766 30.281 14.6274C30.7812 14.4783 31.2367 14.2078 31.607 13.8401L35.167 10.2617C35.2082 10.2139 35.2341 10.1548 35.2414 10.092C35.2487 10.0293 35.2371 9.96585 35.2081 9.90978C35.1791 9.8537 35.134 9.80758 35.0785 9.77734C35.0231 9.7471 34.9599 9.73413 34.897 9.74008",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.b1f3346cbf760d92c8bad2eb818c6065.svg";
export { ForwardRef as ReactComponent };